import { connect } from "react-redux";
import SalesforceExeSetup from "../components/AccountSetting/Salesforce/SalesforceExeSetting/SalesforceExeSetup";
import { goBack, push, replace } from "react-router-redux";
import * as actions from "../redux/actions/Salesforce";
import { getUser } from "../redux/actions/AccountSetting";

const mapStateToProps = (state) => ({
  user: state.accountSetting.user,
  errorMessage: state.sfdcExeSetting.errorMessage,
  shortMessage: state.sfdcExeSetting.shortMessage,
  successMessage: state.sfdcExeSetting.successMessage,
  expiredAccessError: state.sfdcExeSetting.expiredAccessError,
  accountFields: state.sfdcExeSetting.accountFields,
  contactFields: state.sfdcExeSetting.contactFields,
  leadFields: state.sfdcExeSetting.leadFields,
  isLoadingFields: state.sfdcExeSetting.isLoadingFields,
  isConfiguring: state.sfdcExeSetting.isConfiguring,
  isImporting: state.salesforce.isImporting,
  isLoadingConfig: state.salesforce.isLoadingConfig,
  address_import_mappings_flag: state.salesforce.address_import_mappings_flag,
  exe_export_mappings_flag: state.salesforce.exe_export_mappings_flag,
  salesforce_integration_setting_id:
    state.salesforce.salesforce_integration_setting_id,
});

const mapDispatchToProps = (dispatch) => ({
  goBack() {
    dispatch(goBack());
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },

  getUserInfo() {
    dispatch(getUser(true));
  },

  getSalesforceDescribeExeExport() {
    dispatch(actions.getSalesforceDescribeExeExport());
  },

  postSalesforceExportMappingsExe(data) {
    dispatch(actions.postSalesforceExportMappingsExe(data));
  },

  replace(url, state) {
    dispatch(replace(url, state));
  },

  getSalesforceConfig() {
    dispatch(actions.getSalesforceConfig());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SalesforceExeSetup);



// WEBPACK FOOTER //
// ./src/containers/SalesforceExeSetup.js